module.exports = __webpack_public_path__ + "img/2-itol-upload.82f67f16.png";